import { MagnifyingGlassIcon } from '@heroicons/react/20/solid'

const SearchField = ({ handleQuery, setQuery, query }) => {

    const handleChange = (e) => {
        setQuery(e.target.value)
    }

    return( 
            <div className='lg:flex lg:justify-end'>
                <div className="mt-1 flex rounded-md shadow-sm h-10 lg:w-80">
                    <div className="relative flex flex-grow focus-within:z-10">
                        <input
                            onChange={handleChange}
                            value={query}
                            type="text"
                            className="block w-full rounded-none rounded-l-md border-grisMira pl-5 focus:border-secundario focus:ring-secundario sm:text-sm"
                            placeholder="Buscar información"
                        />
                    </div>
                    <button
                        type="submit"
                        onClick={(e) => handleQuery(e, query)}
                        className="relative -ml-px inline-flex items-center space-x-2 rounded-r-md border border-transparent bg-secundario px-4 py-2 text-sm font-medium text-white hover:bg-primarioMira hover:border-secundario hover:border-2"
                    >
                        <MagnifyingGlassIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                </div>
            </div>
    )
}

export default SearchField 
